import React, { useState } from "react";
import { RingLoader } from "react-spinners";
import Slider from "react-slider";
import styled from "styled-components";
import Switch from "react-switch";
import ImageSize from "./ImageSize";

const StyledThumb = styled.div`
    height: 60px;
    width: 9px;
    background: linear-gradient(to right, #bbb, #777);
    cursor: grab;
    border-radius: 25px;
    border: 2px solid #ccc;
`;

const StyledTrack = styled.div`
    top: 10px;
    bottom: 0;
    border-radius: 10px;
    background: linear-gradient(
        to right,
        #0fa ${(props) => (props.index === 1 ? "0%" : "100%")},
        #ddd ${(props) => (props.index === 1 ? "0%" : "100%")}
    );
`;

const Track = ({ index, switchValue, ...props }) => (
    <StyledTrack {...props} index={index} switchValue={switchValue} />
);

const StyledSlider = styled(Slider)`
    width: 100%;
    height: 50px;
`;

const Thumb = (props, state) => <StyledThumb {...props} />;

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em; /* Default font size for desktop */
    padding: 10px 20px; /* Default padding for desktop */
    border-radius: 5px;
    font-weight: bold;

    @media (max-width: 767px) {
        /* Mobile devices */
        font-size: 1.2em; /* Decrease font size for mobile */
        padding: 8px 16px; /* Decrease padding for mobile */
    }

    @media (min-width: 768px) and (max-width: 1023px) {
        /* Tablets */
        font-size: 1.7em; /* Increase font size for tablets */
        padding: 12px 24px; /* Increase padding for tablets */
    }
`;

const PresetButton = styled.button`
    background-color: #48bb78;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    margin: 0 10px;
    font-size: 1em;
    font-weight: bold;
    cursor: pointer;

    &:hover {
        background-color: #38a169;
    }
`;

const StyledLabel = styled.label`
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
`;

const StyledRadio = styled.input`
    margin-right: 8px;
    transform: scale(2);
`;

const StyledDiv = styled.div`
    position: relative;
    width: 260px;
    height: 260px;
    background-color: #fff;
    border: 1px solid #000;
    margin: 0 auto;
    overflow: hidden; /* Add overflow: hidden to clip content */
`;

const ProportionalRectangle = styled.div`
    position: absolute;
    width: ${(props) => props.width - 20}px;
    height: ${(props) => props.height - 20}px;
    background-image: url(${(props) => props.imageUrl});
    background-size: ${(props) => props.width}px auto;
    border: 1px solid #000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(${(props) => props.rotation}deg);
    margin: 5px; /* Set equal margins on all sides */
    padding: 5px; /* Add padding to maintain the size of the rectangle */

    display: flex;
    justify-content: center;
    align-items: center;
`;

const Half = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Letter = styled.div`
    font-size: 24px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; // Use the full height of the viewport
    width: 100%; // Use the full width
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const isMobile = window.innerWidth <= 768;

const IRotateSlider = (props) => {
    const {
        titleDownload,
        titleDownloadAll,
        titleCopy,
        titleCopied,
        titleDelete,
        titleRotateAnotherImage,
        titleRotate,
        titleRotateAll,
        titleFlip,
        titleFlop,
        titleAngelOfRotation,
        titleReady,
        titleCurrentFile,
        tip1,
    } = props.attributes;

    const [isLoading, setIsLoading] = useState(false);
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [thumbnailUrl, setThumbnailUrl] = useState(null);
    const [downloadFileUrls, setDownloadFileUrls] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [flip, setFlip] = useState(false);
    const [flop, setFlop] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showViewer, setShowViewer] = useState(true);

    const handleSliderChange = (value) => {
        setRotation(value);
        setFlip(false);
        setFlop(false);
    };

    const handlePresetClick = (value) => {
        setRotation(value);
        setFlip(false);
        setFlop(false);
    };

    const containerSize = 200; // Size of the container square

    const { imageWidthExt, imageHeightExt } = props;
    let rectangleWidth, rectangleHeight;

    if (imageWidthExt > imageHeightExt) {
        rectangleWidth = containerSize;
        rectangleHeight = (imageHeightExt / imageWidthExt) * containerSize;
    } else {
        rectangleWidth = (imageWidthExt / imageHeightExt) * containerSize;
        rectangleHeight = containerSize;
    }

    const handleOptionChange = (option) => {
        if (option === "flip") {
            setFlip(true);
            setFlop(false);
            setRotation(0);
        } else if (option === "flop") {
            setFlop(true);
            setFlip(false);
            setRotation(0);
        } else {
            setFlip(false);
            setFlop(false);
        }
    };

    const handleRotate = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowViewer(false);

        const requestBody = {
            fileid: props.fileId,
            rotation: rotation,
            flip: flip,
            flop: flop,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/rotateImage?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setThumbnailUrl(responseData.thumbnailUrl);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleRotateAll = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowViewer(false);

        const requestBody = {
            fileid: props.fileId,
            rotation: rotation,
            flip: flip,
            flop: flop,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/rotateImageAll?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setDownloadFileUrls(responseData.fileUrls);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        setDownloadFileUrls(false);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowViewer(true);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const reloadPage = () => {
        setShowViewer(true);
        location.reload();
    };

    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopyToClipboard = (fileUrl, index) => {
        navigator.clipboard.writeText(fileUrl);
        setCopiedIndex(index);

        setTimeout(() => {
            setCopiedIndex(null);
        }, 5000);
    };

    return (
        <Container>
            {showViewer && (
                <div className="irotate-slider">
                    <StyledDiv>
                        <ProportionalRectangle
                            width={rectangleWidth}
                            height={rectangleHeight}
                            imageUrl={props.imageUrl}
                            rotation={rotation}
                        >
                            <Half>
                                <Letter>A</Letter>
                            </Half>
                            <Half>
                                <Letter>B</Letter>
                            </Half>
                        </ProportionalRectangle>
                    </StyledDiv>
                    <div className="px-4 py-2">
                        <div>
                            {titleCurrentFile}: {props.fileName}
                        </div>
                        <div className="slider-container">
                            {titleAngelOfRotation}
                            <StyledSlider
                                min={0}
                                max={360}
                                step={1}
                                value={rotation}
                                onChange={handleSliderChange}
                                className="slider"
                                renderTrack={(props, state) => (
                                    <Track
                                        {...props}
                                        index={state.index}
                                        switchValue={props.switchValue}
                                    />
                                )}
                                renderThumb={Thumb}
                            />
                            <div className="slider-value pt-2">{rotation}°</div>
                            <div className="preset-buttons">
                                <PresetButton
                                    onClick={() => handlePresetClick(90)}
                                >
                                    90°
                                </PresetButton>
                                <PresetButton
                                    onClick={() => handlePresetClick(180)}
                                >
                                    180°
                                </PresetButton>
                                <PresetButton
                                    onClick={() => handlePresetClick(270)}
                                >
                                    270°
                                </PresetButton>
                            </div>
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <div className="options-container">
                            <StyledLabel>
                                <Switch
                                    checked={flip}
                                    onChange={() => handleOptionChange("flip")}
                                    onColor="#48BB78"
                                    onHandleColor="#ffffff"
                                    offColor="#ccc"
                                    offHandleColor="#ffffff"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                                <div className="pl-2">{titleFlip}</div>
                            </StyledLabel>
                            <StyledLabel>
                                <Switch
                                    checked={flop}
                                    onChange={() => handleOptionChange("flop")}
                                    onColor="#48BB78"
                                    onHandleColor="#ffffff"
                                    offColor="#ccc"
                                    offHandleColor="#ffffff"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                                <div className="pl-2">{titleFlop}</div>
                            </StyledLabel>
                        </div>
                    </div>
                    <div className="px-4 py-2 flex justify-center">
                        <ButtonContainer>
                            <StyledButton onClick={handleRotate}>
                                {titleRotate}
                            </StyledButton>
                        </ButtonContainer>
                        <ButtonContainer>
                            <StyledButton onClick={handleRotateAll}>
                                {titleRotateAll}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleRotateAnotherImage}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    {downloadFileUrls && (
                        <ButtonContainer>
                            <div className="pt-2" style={{ display: "flex" }}>
                                <a
                                    href={downloadUrl}
                                    download={getFileName(downloadUrl)}
                                    onClick={handleDownload}
                                >
                                    <StyledButton>
                                        {titleDownloadAll}
                                    </StyledButton>
                                </a>
                                <a className="pl-2" onClick={handleDownload}>
                                    <StyledButtonDelete>
                                        {titleDelete}
                                    </StyledButtonDelete>
                                </a>
                            </div>
                        </ButtonContainer>
                    )}
                    {downloadFileUrls && (
                        <table className="w-full">
                            <thead className="hidden md:table-header-group">
                                <tr>
                                    <th className="text-left text-gray-800">
                                        URL
                                    </th>
                                    <th className="text-left text-gray-800">
                                        {titleDownload}
                                    </th>
                                    <th className="text-left text-gray-800">
                                        {titleCopy}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {downloadFileUrls.map((fileUrl, index) => (
                                    <React.Fragment key={index}>
                                        <tr
                                            key={index}
                                            className="flex flex-col md:table-row"
                                        >
                                            {!isMobile && (
                                                <>
                                                    <td className="md:border md:p-2">
                                                        <div
                                                            className="pt-2"
                                                            style={{
                                                                display: "flex",
                                                            }}
                                                        >
                                                            <img
                                                                src={`${fileUrl}?t=${new Date().getTime()}`}
                                                                alt="Viewer"
                                                                style={{
                                                                    width: "360px",
                                                                    objectFit:
                                                                        "contain",
                                                                }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="pt-2"
                                                            style={{
                                                                display: "flex",
                                                            }}
                                                        >
                                                            <ImageSize
                                                                src={fileUrl}
                                                                attributes={
                                                                    props.attributes
                                                                }
                                                            />
                                                        </div>
                                                    </td>
                                                </>
                                            )}
                                            <td className="md:border p-2 w-full">
                                                <a
                                                    href={fileUrl}
                                                    download={getFileName(
                                                        fileUrl
                                                    )}
                                                    className="w-full break-all block"
                                                >
                                                    {fileUrl}
                                                </a>
                                            </td>
                                            {!isMobile && (
                                                <>
                                                    <td className="md:border md:p-2">
                                                        <a
                                                            href={fileUrl}
                                                            download={getFileName(
                                                                fileUrl
                                                            )}
                                                            className="bg-green-500 text-white px-3 py-2 rounded mr-2 focus:outline-none"
                                                        >
                                                            {titleDownload}
                                                        </a>
                                                    </td>
                                                    <td className="md:border md:p-2">
                                                        <button
                                                            className="bg-blue-500 text-white px-3 py-2 rounded focus:outline-none"
                                                            onClick={() =>
                                                                handleCopyToClipboard(
                                                                    fileUrl,
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            {copiedIndex ===
                                                            index
                                                                ? titleCopied
                                                                : titleCopy}
                                                        </button>
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                        {isMobile && (
                                            <tr className="flex flex-col md:table-row">
                                                <td className="border p-2 flex items-center justify-around">
                                                    <div>
                                                        <a
                                                            href={fileUrl}
                                                            download={getFileName(
                                                                fileUrl
                                                            )}
                                                            className="bg-green-500 text-white px-3 py-2 rounded mr-2 focus:outline-none"
                                                        >
                                                            {titleDownload}
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <button
                                                            onClick={() =>
                                                                navigator.clipboard.writeText(
                                                                    fileUrl
                                                                )
                                                            }
                                                            className="bg-red-500 text-white px-3 py-2 rounded focus:outline-none"
                                                        >
                                                            {titleCopy}
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    )}
                    <ButtonContainer>
                        {!downloadFileUrls && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={thumbnailUrl}
                                    alt="Viewer"
                                    style={{
                                        width: "360px",
                                        objectFit: "contain",
                                    }}
                                />
                                <div
                                    className="pt-2"
                                    style={{ display: "flex" }}
                                >
                                    <ImageSize
                                        src={thumbnailUrl}
                                        attributes={props.attributes}
                                    />
                                </div>
                                <div
                                    className="pt-2"
                                    style={{ display: "flex" }}
                                >
                                    <a
                                        href={downloadUrl}
                                        download={getFileName(downloadUrl)}
                                        onClick={handleDownload}
                                    >
                                        <StyledButton>
                                            {titleDownload}
                                        </StyledButton>
                                    </a>
                                    <a
                                        className="pl-2"
                                        onClick={handleDownload}
                                    >
                                        <StyledButtonDelete>
                                            {titleDelete}
                                        </StyledButtonDelete>
                                    </a>
                                </div>
                            </div>
                        )}
                    </ButtonContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleRotateAnotherImage}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default IRotateSlider;
